(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/common/directives/noDataAvailable.tpl.html',
    '<div class="alerts"><div class="alert-message error"><p translate="userRight.notAvailable"></p></div><style>\n' +
    '    .alerts {\n' +
    '      margin: 20px;\n' +
    '    }\n' +
    '\n' +
    '    .alerts p {\n' +
    '      /* quick and dirty hack added by me, you may remove it if not needed */\n' +
    '      margin: 0;\n' +
    '      padding: 0;\n' +
    '    }\n' +
    '\n' +
    '    .alert-message.danger, .alert-message.danger:hover, .alert-message.error, .alert-message.error:hover, .alert-message.success, alert-message.success:hover, .alert-message.info, .alert-message.info:hover {\n' +
    '      color: #ffffff;\n' +
    '    }\n' +
    '\n' +
    '    .alert-message .close {\n' +
    '     \n' +
    '      line-height: 18px;\n' +
    '    }\n' +
    '\n' +
    '    .alert-message.danger, .alert-message.error {\n' +
    '      background-color: #b5000d;\n' +
    '      background-repeat: repeat-x;\n' +
    '\n' +
    '      background-image: -khtml-gradient(linear, left top, left bottom, from(#ef4136), to(#b5000d));\n' +
    '      background-image: -moz-linear-gradient(top, #ef4136, #b5000d);\n' +
    '      background-image: -ms-linear-gradient(top, #ef4136, #b5000d);\n' +
    '      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #ef4136), color-stop(100%, #b5000d));\n' +
    '      background-image: -webkit-linear-gradient(top, #ef4136, #b5000d);\n' +
    '      background-image: -o-linear-gradient(top, #ef4136, #b5000d);\n' +
    '      background-image: linear-gradient(top, #ef4136, #b5000d);\n' +
    '      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#ef4136\', endColorstr=\'#b5000d\', GradientType=0);\n' +
    '\n' +
    '      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n' +
    '      border-color: #ef4136 #ef4136 #b5000d;\n' +
    '      border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n' +
    '    }\n' +
    '\n' +
    '    .alert-message.success {\n' +
    '      background-color: #57a957;\n' +
    '      background-repeat: repeat-x;\n' +
    '\n' +
    '      background-image: -khtml-gradient(linear, left top, left bottom, from(#62c462), to(#57a957));\n' +
    '      background-image: -moz-linear-gradient(top, #62c462, #57a957);\n' +
    '      background-image: -ms-linear-gradient(top, #62c462, #57a957);\n' +
    '      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #62c462), color-stop(100%, #57a957));\n' +
    '      background-image: -webkit-linear-gradient(top, #62c462, #57a957);\n' +
    '      background-image: -o-linear-gradient(top, #62c462, #57a957);\n' +
    '      background-image: linear-gradient(top, #62c462, #57a957);\n' +
    '      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#62c462\', endColorstr=\'#57a957\', GradientType=0);\n' +
    '\n' +
    '      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n' +
    '      border-color: #57a957 #57a957 #3d773d;\n' +
    '      border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n' +
    '    }\n' +
    '\n' +
    '    .alert-message.info {\n' +
    '      background-color: #339bb9;\n' +
    '      background-repeat: repeat-x;\n' +
    '\n' +
    '      background-image: -khtml-gradient(linear, left top, left bottom, from(#5bc0de), to(#339bb9));\n' +
    '      background-image: -moz-linear-gradient(top, #5bc0de, #339bb9);\n' +
    '      background-image: -ms-linear-gradient(top, #5bc0de, #339bb9);\n' +
    '      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #5bc0de), color-stop(100%, #339bb9));\n' +
    '      background-image: -webkit-linear-gradient(top, #5bc0de, #339bb9);\n' +
    '      background-image: -o-linear-gradient(top, #5bc0de, #339bb9);\n' +
    '      background-image: linear-gradient(top, #5bc0de, #339bb9);\n' +
    '      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#5bc0de\', endColorstr=\'#339bb9\', GradientType=0);\n' +
    '\n' +
    '      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n' +
    '      border-color: #339bb9 #339bb9 #22697d;\n' +
    '      border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n' +
    '    }\n' +
    '\n' +
    '    :root .alert-message {\n' +
    '      border-radius: 0 \\0;\n' +
    '    }\n' +
    '\n' +
    '    .close {\n' +
    '      float: right;\n' +
    '      color: #000000;\n' +
    '      font-size: 20px;\n' +
    '      font-weight: bold;\n' +
    '      line-height: 13.5px;\n' +
    '      text-shadow: 0 1px 0 #ffffff;\n' +
    '      filter: alpha(opacity=25);\n' +
    '      -khtml-opacity: 0.25;\n' +
    '      -moz-opacity: 0.25;\n' +
    '      opacity: 0.25;\n' +
    '    }\n' +
    '\n' +
    '    .close:hover {\n' +
    '      color: #000000;\n' +
    '      text-decoration: none;\n' +
    '      filter: alpha(opacity=40);\n' +
    '      -khtml-opacity: 0.4;\n' +
    '      -moz-opacity: 0.4;\n' +
    '      opacity: 0.4;\n' +
    '    }\n' +
    '\n' +
    '    .alert-message {\n' +
    '      \n' +
    '      font-size: 13px;\n' +
    '\n' +
    '      position: relative;\n' +
    '      padding: 7px 15px;\n' +
    '      margin-bottom: 18px;\n' +
    '      color: #404040;\n' +
    '\n' +
    '      background-color: #eedc94;\n' +
    '      background-repeat: repeat-x;\n' +
    '\n' +
    '      background-image: -khtml-gradient(linear, left top, left bottom, from(#fceec1), to(#eedc94));\n' +
    '      background-image: -moz-linear-gradient(top, #fceec1, #eedc94);\n' +
    '      background-image: -ms-linear-gradient(top, #fceec1, #eedc94);\n' +
    '      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #fceec1), color-stop(100%, #eedc94));\n' +
    '      background-image: -webkit-linear-gradient(top, #fceec1, #eedc94);\n' +
    '      background-image: -o-linear-gradient(top, #fceec1, #eedc94);\n' +
    '      background-image: linear-gradient(top, #fceec1, #eedc94);\n' +
    '      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#fceec1\', endColorstr=\'#eedc94\', GradientType=0);\n' +
    '\n' +
    '      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n' +
    '      border-color: #eedc94 #eedc94 #e4c652;\n' +
    '      border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n' +
    '      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);\n' +
    '      border-width: 1px;\n' +
    '      border-style: solid;\n' +
    '\n' +
    '      -webkit-border-radius: 4px;\n' +
    '      -moz-border-radius: 4px;\n' +
    '      border-radius: 4px;\n' +
    '\n' +
    '      -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);\n' +
    '      -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);\n' +
    '      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);\n' +
    '    }\n' +
    '\n' +
    '    .alert-message .close {\n' +
    '      margin-top: 0;\n' +
    '    }\n' +
    '\n' +
    '    .alert-message a {\n' +
    '      font-weight: bold;\n' +
    '      color: #404040;\n' +
    '      text-decoration: none;\n' +
    '    }\n' +
    '\n' +
    '    .alert-message.danger p a, .alert-message.error p a, .alert-message.success p a, .alert-message.info p a {\n' +
    '      color: #ffffff;\n' +
    '    }\n' +
    '\n' +
    '    .alert-message p a:hover {\n' +
    '      text-decoration: underline;\n' +
    '    }\n' +
    '\n' +
    '    .alert-message p {\n' +
    '      margin-bottom: 0;\n' +
    '    }\n' +
    '  </style></div>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/common/directives/noDataAvailable.tpl.js